/* @flow */
/* eslint-disable babel/no-invalid-this */
import safeAccess from "safe-access";
import type { BarrierFeature } from "./types";

export default function Barrier(feature: BarrierFeature) {
  let operateAction = feature.actions.operate;

  this.isBarrierClosed = () => {
    return this.get("status") === "closed";
  };

  this.isBarrierOperable = () => operateAction != null;

  this.getCurrentBarrierOperation = () => {
    return safeAccess(operateAction, "title");
  };

  this.operateBarrier = () => {
    if (!this.isBarrierOperable()) {
      return Promise.reject(
        new Error("Can't operate a barrier that isn't operable")
      );
    }
    return this.executeDeviceActionThenFetch(operateAction, {});
  };

  return { status: feature.status };
}



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/barrier.js